import {PayloadAction} from "@reduxjs/toolkit";

export function onActionbarTypeChange (state: ActionbarState, action: PayloadAction<ActionbarType>): void {
    state.actionbarType = action.payload;
}

export function onActionbarStatusChange (state: ActionbarState, action: PayloadAction<ActionbarStatus>): void {
    state.actionbarStatus = action.payload;
}

export function onOpenOrderNameChange (state: ActionbarState, action: PayloadAction<string>): void {
    state.openOrderName = action.payload;
}

export interface ActionbarState {
    actionbarType: ActionbarType,
    actionbarStatus: ActionbarStatus,
    openOrderName: string | undefined,
}

export enum ActionbarType {
    ORDERS, USER_SETTINGS, RECIPIENTS, CALCULATE
}

export enum ActionbarStatus {
    DEFAULT,
    EXISTING_ORDER_MODIFIED,
}

